/**
 * Customer + primary-driver form section for `ManualBookingDialog`. Auto-create
 * happens server-side when the email is new. Required fields (name, email)
 * are gated at submit; identity fields are optional here but required at
 * rental-agreement signing time, hence the helper text.
 */
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import CountryCombobox from "@/components/profile/CountryCombobox";

export function ManualBookingCustomerForm({ form, set }) {
  return (
    <div className="rounded-xl border border-border p-3 bg-neutral-50/40">
      <div className="text-xs uppercase tracking-wider text-neutral-500 font-semibold mb-2">Customer · primary driver</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <Label>Full name <span className="text-rose-500">*</span></Label>
          <Input value={form.customer_name} onChange={(e) => set("customer_name")(e.target.value)} className="mt-1 rounded-xl bg-white" data-testid="manual-booking-customer-name" />
        </div>
        <div>
          <Label>Email <span className="text-rose-500">*</span></Label>
          <Input type="email" value={form.customer_email} onChange={(e) => set("customer_email")(e.target.value)} className="mt-1 rounded-xl bg-white" data-testid="manual-booking-customer-email" />
        </div>
        <div className="md:col-span-2">
          <Label>Phone or WhatsApp</Label>
          <Input value={form.customer_phone} onChange={(e) => set("customer_phone")(e.target.value)} placeholder="+33 6 12 34 56 78" className="mt-1 rounded-xl bg-white" data-testid="manual-booking-customer-phone" />
        </div>
        <div className="md:col-span-2">
          <Label>Full address</Label>
          <Input value={form.customer_address} onChange={(e) => set("customer_address")(e.target.value)} placeholder="Street, city, postcode" className="mt-1 rounded-xl bg-white" data-testid="manual-booking-customer-address" />
        </div>
        <div>
          <Label>Country</Label>
          <div className="mt-1">
            <CountryCombobox
              value={form.customer_country || ""}
              onChange={(code) => set("customer_country")(code)}
              placeholder="Pick a country…"
              testId="manual-booking-customer-country"
            />
          </div>
        </div>
        <div>
          <Label>Passport / ID number</Label>
          <Input value={form.customer_id_number} onChange={(e) => set("customer_id_number")(e.target.value)} placeholder="ID or passport no." className="mt-1 rounded-xl bg-white" data-testid="manual-booking-customer-id-number" />
        </div>
        <div>
          <Label>Driver licence number</Label>
          <Input value={form.customer_license_number} onChange={(e) => set("customer_license_number")(e.target.value)} className="mt-1 rounded-xl bg-white" data-testid="manual-booking-customer-license" />
        </div>
        <div>
          <Label>Licence expiry</Label>
          <Input type="date" value={form.customer_license_expiry} onChange={(e) => set("customer_license_expiry")(e.target.value)} className="mt-1 rounded-xl bg-white" data-testid="manual-booking-customer-license-expiry" />
        </div>
      </div>
      <p className="text-[10px] text-neutral-500 mt-2">
        All fields except name + email are optional but required for the rental agreement at pickup.
        If this email already has an account, the booking attaches to it.
      </p>
    </div>
  );
}

export default ManualBookingCustomerForm;
